var ROUTE_PREFIX = "/package/portals";
var ENDPOINT_PACKAGE_VERSION = ROUTE_PREFIX + "/version";
var fetchPortals = ROUTE_PREFIX + "/users/portals";
var markPortalLogin = ROUTE_PREFIX + "/contacts/enter";
var portalsPortalEndpoints = {
    fetchPortals: fetchPortals,
    markPortalLogin: markPortalLogin,
};
var fetchPortalsCRM = function (contactZohoId) {
    return ROUTE_PREFIX + "/contacts/" + contactZohoId + "/portals";
};
var toggleCredentials = function (contactZohoId) {
    return ROUTE_PREFIX + "/users/" + contactZohoId + "/credentials";
};
// common (customer and company)
var resetPassword = function (contactZohoId) {
    return ROUTE_PREFIX + "/contacts/" + contactZohoId + "/password-reset";
};
var changeStatus = function (contactZohoId) {
    return ROUTE_PREFIX + "/contacts/" + contactZohoId + "/status";
};
var changeEmail = function (contactZohoID) {
    return ROUTE_PREFIX + "/contacts/" + contactZohoID + "/email/";
};
// invite routes
var resendPortalInvite = function (contactZohoId, portal) {
    return ROUTE_PREFIX + "/contacts/" + contactZohoId + "/portals/" + portal + "/resend-invite";
};
var sendPortalInvite = function (contactZohoId, portal) {
    return ROUTE_PREFIX + "/contacts/" + contactZohoId + "/portals/" + portal + "/invite";
};
var portalsCRMEndpoints = {
    fetchPortalsCRM: fetchPortalsCRM,
    toggleCredentials: toggleCredentials,
    resetPassword: resetPassword,
    changeStatus: changeStatus,
    changeEmail: changeEmail,
};
// contact
var fetchContactByEmail = function (email) {
    return ROUTE_PREFIX + "/contacts/email/" + email + "/crm";
};
var fetchContactByZohoID = function (contactZohoId) {
    return ROUTE_PREFIX + "/contacts/" + contactZohoId;
};
var portalsContactEndpoints = {
    fetchContactByEmail: fetchContactByEmail,
    fetchContactByZohoID: fetchContactByZohoID,
};

var StatusEnum;
(function (StatusEnum) {
    StatusEnum["Inactive"] = "Inactive";
    StatusEnum["Pending"] = "Pending";
    StatusEnum["Active"] = "Active";
    StatusEnum["Deactivated"] = "Deactivated";
})(StatusEnum || (StatusEnum = {}));
var PortalType;
(function (PortalType) {
    PortalType["Company"] = "Company";
    PortalType["Static"] = "Static";
})(PortalType || (PortalType = {}));

export { ENDPOINT_PACKAGE_VERSION, PortalType, ROUTE_PREFIX, StatusEnum, changeEmail, changeStatus, fetchContactByEmail, fetchContactByZohoID, fetchPortals, fetchPortalsCRM, markPortalLogin, portalsCRMEndpoints, portalsContactEndpoints, portalsPortalEndpoints, resendPortalInvite, resetPassword, sendPortalInvite, toggleCredentials };
//# sourceMappingURL=index.esm.js.map
